import axios from 'axios'
import router from '../router'
import common from '@/js/common'
import constants from '@/js/constants.js'
import user from "@/js/user";

const TIME_OUT_MS = 60 * 1000 // 默认请求超时时间


/*
 * @param response 返回数据列表
 */
function handleResults(response) {
    let remoteResponse = response.data
    var result = {
        success: false,
        message: '',
        errorCode: 0,
        datas: {}
    }
    if (remoteResponse.code == 200) {
        result.datas = remoteResponse
        result.success = true
    } else {
        result.errorCode = remoteResponse.code
        result.message = remoteResponse.message
        result.success = false
        user.data = {}
        if ('205' === result.errorCode) {
            common.remove(constants.sessions_key)
            router.push({
                path: '/'
            })
        }
    }
    return result
}

function handleUrl(url) {
    // BASE_URL是接口的ip前缀，比如http:10.100.1.1:8989/
    url = process.env.API_ROOT + url
    return url
}

/*
 * @param data 参数列表
 * @return
 */
function handleParams(data) {
    return data
}

export default {
    /*
     * @param url
     * @param data
     * @param response 请求成功时的回调函数
     * @param exception 异常的回调函数
     */
    post(url, data, response, exception) {
        // 添加请求拦截器
        // axios.interceptors.request.use(function (config) {
        //     if (common.fetch(this.GLOBAL.USER_SESSION_KEY)) {
                
        //     }
        // }, function (error) {
        //     // 对请求错误做些什么
        //     return Promise.reject(error);
        // });
        axios({
            method: 'post',
            url: handleUrl(url),
            data: handleParams(data),
            timeout: TIME_OUT_MS,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            }
        }).then(
            (result) => {
                console.log(result)
                response(handleResults(result))
            }
        ).catch(
            (error) => {
                if (exception) {
                    exception(error)
                } else {
                    console.log(error)
                }
            }
        )
    },
    /*
     * get 请求
     * @param url
     * @param response 请求成功时的回调函数
     * @param exception 异常的回调函数
     */
    get(url, response, exception) {
        axios({
            method: 'get',
            url: handleUrl(url),
            timeout: TIME_OUT_MS,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            }
        }).then(
            (result) => {
                response(handleResults(result))
            }
        ).catch(
            (error) => {
                if (exception) {
                    exception(error)
                } else {
                    console.log(error)
                }
            }
        )
    }
}


// WEBPACK FOOTER //
// ./src/js/http.js